import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, HostBinding, inject, signal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { AppConfigService } from '@core/services';
import { TranslateModule } from '@ngx-translate/core';
import { ShellController } from '@shell/services';
import { MirIcon } from '@widgets/mir-icon';

const USER_ICONS = {
  'Admin': 'admin_panel_settings',
  'Standard': 'person'
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ShellHeader',
  templateUrl: './shell-header.component.html',
  styleUrl: './shell-header.component.scss',
  imports: [
    CommonModule,
    RouterModule,
    MatMenuModule,
    TranslateModule,
    MirIcon,
  ]
})
export class ShellHeader {

  @HostBinding('class')
  get hostCssClass(): string {
    return `group/ShellHeader`;
  }

  @HostBinding('class.admin')
  get cssAdminClass(): boolean { return this.isAdministrator(); }

  /** @Inject */
  readonly #appConfigService = inject(AppConfigService);
  readonly #shellController = inject(ShellController);

  protected readonly titleStart = signal('');
  protected readonly titleEnd = signal('');
  protected readonly hasUser = computed(() => this.#shellController.hasUser());
  protected readonly isAdministrator = computed(() => this.#shellController.isUserAdministrator());
  protected readonly fullName = computed(() => this.#shellController.userFullName());
  protected readonly userIcon = computed(() => USER_ICONS[this.#shellController.isUserAdministrator() ? 'Admin' : 'Standard']);

  constructor() {
    effect(() => {
      const title = this.#shellController.title();
      const titleParts = title.split(' ');
      const titleStart = titleParts.shift();
      const titleEnd = titleParts.join(' ');

      this.titleStart.set(titleStart);
      this.titleEnd.set(titleEnd || '');

    });
  }

  get defaultLogoLink(): string { return this.#appConfigService.get('baseRouteRedirect'); }

  handleLogout() {
    this.#shellController.logout();
  }

  handleOpenSettings() {
    this.#shellController.openSettings();
  }
}
